<div class="modal fade text-center" id="modal-avisos-novidades" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header justify-content-between">
            <h5 class="modal-title" id="exampleModalLabel"> {{ titulo }}</h5>
            <img data-bs-dismiss="modal"  class='bt-fechar' src="assets/img/icon_bt-limpar_header.svg">
        </div>
        <div class="modal-body "  >
          <div *ngFor="let slide of slides" >
            <div  *ngIf="pagina == slide.Pagina"  class="height-aviso grid-aviso">
              <div class="form-inline mb-3" style="justify-content: center" *ngIf="slides.length > 1">
                <div class="btn-group" btnRadioGroup >
                  <label class="btn btn-success me-1" *ngFor="let slide of slides" [btnRadio]=slide.Pagina (click)="alteraPaginaSlide(slide)">{{ slide.Pagina }}</label>
                </div> 
              </div> 
              <h6 class=" font-weight-bold"> {{slide.TextoPrincipal }}</h6>        
              <a [href]="slide.Url" target="_blank" *ngIf="slide.Url; else semUrl" >
                <img [src]="slide.Imagem" alt="Imagem novidade" class="novo-rota-img">
              </a> 
              <ng-template #semUrl>
                <img [src]="slide.Imagem" alt="Imagem novidade" class="novo-rota-img cursor-none">
              </ng-template>              
              <div class="mt-2">
                <p class="mb-0"> {{ slide.Conteudo }} </p>
                <p class="mb-1" > {{ slide.SubConteudo }}  </p> 
                <button  class="btn btn-success" (click)="slide.OnPressed()" *ngIf="slide.MostrarBtn"> {{ slide.TxtBtn }} </button>
              </div>          
              <p class="mt-3 mt-3"> {{ slide.ConteudoFooter }} </p>   
            </div>
        </div>       
      </div>      
    </div>
  </div>
</div>